<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des astuces</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div slot="date_debut" slot-scope="props">{{ formatDate(props.row.date_debut) }}</div>
          <div slot="date_fin" slot-scope="props">{{ props.row.date_fin !== null ? formatDate(props.row.date_fin) :
            'n.d' }}
          </div>
          <div slot="titre" slot-scope="props">{{ props.row.titre }}</div>
          <div slot="nature" slot-scope="props">{{ props.row.nature }}</div>
          <div slot="action" slot-scope="props">
            <b-button
              v-if="canAccess(rules.MANAGE_ASTUCES)"
              type="button"
              @click.prevent="destroy(props.row.id)"
              class="badge badge-danger mr-3 p-2">
              <i class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button
              v-if="canAccess(rules.MANAGE_ASTUCES)"
              type="button"
              @click="edit(props.row.id)"
              class="badge badge-primary p-2">
              <i class="fa fa-eye"></i> Voir
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button" @click="add" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une astuce
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import {rules, hasRule} from '../../../utils/rulesHelper'

  export default {
    name: "List",
    data() {
      let self = this;
      return {
        rules: rules,
        items: [],
        columns: ["titre", "action"],
        options: {
          headings: {
            titre: "Titre",
            action: "Action",
          },
          sortable: ["titre"],
          filterable: false,
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Titre"
          },
          orderBy: {ascending: true},
        }
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    mounted() {
      this.getAstuces();
    },
    methods: {
      getAstuces() {
        let self = this;
        this.$axios
          .get('/administration/astuces')
          .then((response) => {
            this.items = response.data.astuces;
          })
          .catch(() => {
            this.handleErrors(self);
          });
      },
      destroy(id) {
        let self = this;
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: "Voulez-vous supprimer cette astuce ?",
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor: "#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true);
            this.$axios
              .get(`/administration/astuces/delete/${id}`)
              .then(() => {
                this.getAstuces();
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Suppression avec succès',
                  text: "L'astuce a bien été supprimée",
                  showConfirmButton: false,
                  timer: 3000
                });
              })
              .catch(function () {
                self.handleErrors(self);
              })
              .finally(() => {
                this.$store.commit('IS_LOADING', false)
              });
          }
        })
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      add() {
        this.$router.push({path: '/administration/astuces/add'});
      },
      edit(id) {
        this.$router.push({path: '/administration/astuces/edit/' + id});
      },
      handleErrors(self) {
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: "Une erreur est survenue lors de l'ajout de l'astuce. Si le problème persiste, merci de faire un ticket au support DOSI.",
          showConfirmButton: false,
          timer: 4000
        });
      },
      canAccess(rule) {
        return hasRule(rule);
      },
    }
  }
</script>
